"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _useStyles = require("../../../hooks/useStyles");

var _video = require("../../video/video");

var _const = require("../../../const");

var _video2 = require("../../video");

var _slideContent = require("../components/slide-content/slide-content");

var _heroSlide = require("../hero-slide.styled");

var _heroSlideUi = require("./hero-slide-ui.styled");

var _style = _interopRequireDefault(require("./style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var HeroSlideUi = function HeroSlideUi(_ref) {
  var lineOneText = _ref.lineOneText,
      lineTwoText = _ref.lineTwoText,
      lineThreeText = _ref.lineThreeText,
      contentPosition = _ref.contentPosition,
      textAlign = _ref.textAlign,
      textBackgroundColor = _ref.textBackgroundColor,
      textColor = _ref.textColor,
      fullWidth = _ref.fullWidth,
      thumbnail = _ref.thumbnail,
      fileReference = _ref.fileReference,
      buttons = _ref.buttons,
      _ref$autoPlay = _ref.autoPlay,
      autoPlay = _ref$autoPlay === void 0 ? false : _ref$autoPlay;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isPlaying = _useState2[0],
      setIsPlaying = _useState2[1];

  var _useState3 = (0, _react.useState)(autoPlay),
      _useState4 = _slicedToArray(_useState3, 2),
      isMuted = _useState4[0],
      setIsMuted = _useState4[1];

  var textProps = {
    contentPosition: contentPosition,
    textAlign: textAlign,
    textColor: textColor,
    textBackgroundColor: textBackgroundColor,
    hideMdHeight: fullWidth
  };
  var currentButtons = fullWidth ? [] : buttons;

  var handleVideoPlayed = function handleVideoPlayed() {
    setIsPlaying(true);
  };

  var handleVideoPaused = function handleVideoPaused() {
    setIsPlaying(false);
  };

  var handleClick = function handleClick(e) {
    e.nativeEvent.stopImmediatePropagation();

    if (autoPlay && isMuted) {
      setIsMuted(false);
      handleVideoPaused();
      setTimeout(function () {
        handleVideoPlayed();
      }, 0);
      return;
    }

    if (isPlaying) {
      handleVideoPaused();
    } else {
      handleVideoPlayed();
    }
  };

  var handleEnd = function handleEnd() {
    setIsPlaying(false);
  };

  (0, _react.useEffect)(function () {
    if (autoPlay) {
      setIsPlaying(true);
    } else {
      setIsPlaying(false);
    }
  }, [autoPlay]);
  var noContent = fullWidth && !lineOneText && !lineTwoText && !lineThreeText;
  var isContentVisible = !isPlaying || !fullWidth;
  var styles = fullWidth ? (0, _useStyles.useStyles)('a', _style.default) : (0, _useStyles.useStyles)('b', _style.default);
  return (
    /*#__PURE__*/
    // @ts-ignore
    _react.default.createElement(_uiKit.ThemeProvider, {
      theme: {
        styles: styles,
        $isPlaying: isPlaying
      }
    }, /*#__PURE__*/_react.default.createElement(_heroSlide.CarouselWrapper, {
      "data-test": _const.TestType.COMPONENT,
      "data-test-id": _const.TestValue.AEM_HERO_SLIDE_VIDEO
    }, /*#__PURE__*/_react.default.createElement(_heroSlideUi.Container, _extends({}, textProps, {
      onClick: fullWidth ? handleClick : null
    }), !noContent && /*#__PURE__*/_react.default.createElement(_heroSlideUi.ColStyled, {
      sm: 6,
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(_heroSlideUi.ContentWrapper, {
      visible: isContentVisible
    }, /*#__PURE__*/_react.default.createElement(_slideContent.SlideContent, {
      line1: lineOneText,
      line2: lineTwoText,
      line3: lineThreeText,
      buttons: currentButtons,
      bg: textBackgroundColor
    }), fullWidth && /*#__PURE__*/_react.default.createElement(_video.PlayButtonComponent, {
      isPlaying: isPlaying,
      mt: 20,
      onClick: handleClick
    }))), /*#__PURE__*/_react.default.createElement(_heroSlideUi.ColStyled, {
      sm: 6,
      xs: 12,
      alignSelf: "stretch",
      fullWidth: fullWidth,
      showBtn: !isPlaying && noContent
    }, /*#__PURE__*/_react.default.createElement(_heroSlideUi.VideoWrapper, {
      onClick: handleClick,
      isPlaying: isPlaying
    }, /*#__PURE__*/_react.default.createElement(_video2.Video, {
      muted: true,
      volume: 0,
      config: {
        file: {
          attributes: {
            preload: 'none',
            muted: isMuted,
            volume: 0,
            autoPlay: autoPlay
          },
          forceVideo: true
        }
      },
      src: fileReference,
      playsinline: true,
      playing: isPlaying,
      preview: thumbnail,
      onPlay: handleVideoPlayed,
      onPause: handleVideoPaused,
      wrapper: _heroSlideUi.VideoItemWrapper,
      playIcon: /*#__PURE__*/_react.default.createElement("span", null),
      onClick: handleClick,
      onEnded: handleEnd,
      cover: true
    }), /*#__PURE__*/_react.default.createElement(_video.PlayButtonComponent, {
      isPlaying: isPlaying,
      centered: true,
      onClick: handleClick
    }), /*#__PURE__*/_react.default.createElement(_video.PauseButtonComponent, {
      isPlaying: isPlaying
    }))))))
  );
};

var _default = HeroSlideUi;
exports.default = _default;